/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Username1Inputs */

const en_entity_username1 = /** @type {(inputs: Entity_Username1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`User Name`)
};

const de_entity_username1 = /** @type {(inputs: Entity_Username1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benutzername`)
};

/**
* | output |
* | --- |
* | "User Name" |
*
* @param {Entity_Username1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_username1 = /** @type {((inputs?: Entity_Username1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Username1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_username1(inputs)
	return de_entity_username1(inputs)
});
export { entity_username1 as "entity_userName" }